import { render, staticRenderFns } from "./BaseCarddraw.vue?vue&type=template&id=80f8e738&scoped=true&"
import script from "./BaseCarddraw.vue?vue&type=script&lang=js&"
export * from "./BaseCarddraw.vue?vue&type=script&lang=js&"
import style0 from "./BaseCarddraw.vue?vue&type=style&index=0&id=80f8e738&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f8e738",
  null
  
)

export default component.exports